import React, {Component} from "react";
import PageTitle from "../../component/PageTitle";
import DashboardData from "../../../logic/objects/DashboardData";
import Card from "../../component/Card";
import DashboardGraph from "../../component/DashboardGraph";
// noinspection ES6CheckImport
import {Chart} from 'react-chartjs-2';
import zoomPlugin from 'chartjs-plugin-zoom';
import {endPreLoad, refreshIfNeeded} from "../../../logic/functions/Basic";
import {getDashboard} from "../../../logic/functions/ServerPetitions";

import '../../../../css/sb-admin-2.css';
import '../../../../css/dashboard.css';

// Clase que contiene el contenido de la página Dasboard.
// noinspection DuplicatedCode
class Dashboard extends Component {
    // Constructor de clase Dashboard.
    constructor(props) {
        super(props);
        this.graphs = [];
    }

    // Función que se realiza cuando se ha cargado el DOM, realiza las peticiones iniciales.
    componentDidMount = () => {
        document.title = this.props.strings.dashboardTitle;
        Chart.register(zoomPlugin);

        getDashboard().then(async dashboard => {
            const dashboardJson = await dashboard.json();

            if (!dashboard.ok){
                const error = ((dashboardJson && dashboardJson.error) || dashboard.status);
                window.location.href = '/';
                return Promise.reject(error);
            }

            if (dashboardJson.hasOwnProperty('data')){
                const dashboardData = new DashboardData(dashboardJson.data);
                this.fillBasicInformationDashboard(dashboardData);
                this.fillChartInformationDashboard(dashboardData);
                endPreLoad();
            } else {
                refreshIfNeeded(dashboardJson, null, this.props.showInfoModal);
            }
        }).catch( error => {
                this.props.showInfoModal(this.props.strings.getModalErrorTitle, this.props.strings.getModalErrorBody);
                console.log(error);
                endPreLoad();
            }
        );
    }

    // Dibuja los elementos de la página.
    render = () => {
        // noinspection HtmlUnknownAnchorTarget
        return (
            <div className="container-fluid">

                {/* Page Heading */}
                <PageTitle text={"Información general"}/>

                {/* Content Row */}
                <div className="row">
                    {/* Card numero usuarios */}
                    <div className="col-xl-3 col-md-6 mb-4">
                        <Card id={"userAmount"} cardColorClass={"border-left-primary"} titleColorClass={"text-primary"} text={"Nº usuarios"} iconClass={"fa-users"} />
                    </div>
                    {/* Card numero explotaciones */}
                    <div className="col-xl-3 col-md-6 mb-4">
                        <Card id={"farmAmount"} cardColorClass={"border-left-primary"} titleColorClass={"text-primary"} text={"Nº explotaciones"} iconClass={"fa-mountain"} />
                    </div>
                    {/* Card numero temporadas */}
                    <div className="col-xl-3 col-md-6 mb-4">
                        <Card id={"seasonAmount"} cardColorClass={"border-left-primary"} titleColorClass={"text-primary"} text={"Nº temporadas"} iconClass={"fa-mountain"} />
                    </div>
                    {/* Card numero cultivos */}
                    <div className="col-xl-3 col-md-6 mb-4">
                        <Card id={"cropAmount"} cardColorClass={"border-left-primary"} titleColorClass={"text-primary"} text={"Nº cultivos"} iconClass={"fa-carrot"} />
                    </div>
                    {/* Card numero maquinaria */}
                    <div className="col-xl-3 col-md-6 mb-4">
                        <Card id={"machineAmount"} cardColorClass={"border-left-primary"} titleColorClass={"text-primary"} text={"Nº maquinaria"} iconClass={"fa-tractor"} />
                    </div>
                    {/* Card numero mensajes */}
                    <div className="col-xl-3 col-md-6 mb-4">
                        <Card id={"messageAmount"} cardColorClass={"border-left-primary"} titleColorClass={"text-primary"} text={"Nº mensajes"} iconClass={"fa-envelope"} />
                    </div>
                    {/* Card numero notificaciones */}
                    <div className="col-xl-3 col-md-6 mb-4">
                        <Card id={"notificationAmount"} cardColorClass={"border-left-primary"} titleColorClass={"text-primary"} text={"Nº notificaciones"} iconClass={"fa-bell"} />
                    </div>
                </div>

                {/* Page Heading */}
                <PageTitle text={"Incidencias"}/>

                {/* Content Row */}
                <div className="row">
                    {/* Card numero siembras */}
                    <div className="col-xl-3 col-md-6 mb-4">
                        <Card id={"seedAmount"} cardColorClass={"border-left-danger"} titleColorClass={"text-danger"} text={"Nº siembras"} iconClass={"fa-exclamation"} />
                    </div>
                    {/* Card numero plantaciones */}
                    <div className="col-xl-3 col-md-6 mb-4">
                        <Card id={"plantAmount"} cardColorClass={"border-left-danger"} titleColorClass={"text-danger"} text={"Nº plantaciones"} iconClass={"fa-exclamation"} />
                    </div>
                    {/* Card numero cubiertas */}
                    <div className="col-xl-3 col-md-6 mb-4">
                        <Card id={"coverAmount"} cardColorClass={"border-left-danger"} titleColorClass={"text-danger"} text={"Nº cubiertas"} iconClass={"fa-exclamation"} />
                    </div>
                    {/* Card numero pastoreos */}
                    <div className="col-xl-3 col-md-6 mb-4">
                        <Card id={"shepherdAmount"} cardColorClass={"border-left-danger"} titleColorClass={"text-danger"} text={"Nº pastoreos"} iconClass={"fa-exclamation"} />
                    </div>
                    {/* Card numero fitosanitarios */}
                    <div className="col-xl-3 col-md-6 mb-4">
                        <Card id={"phytosanitaryAmount"} cardColorClass={"border-left-danger"} titleColorClass={"text-danger"} text={"Nº fitosanitarios"} iconClass={"fa-exclamation"} />
                    </div>
                    {/* Card numero trat. no químicos */}
                    <div className="col-xl-3 col-md-6 mb-4">
                        <Card id={"defenseAmount"} cardColorClass={"border-left-danger"} titleColorClass={"text-danger"} text={"Nº trat. no químicos"} iconClass={"fa-exclamation"} />
                    </div>
                    {/* Card numero planes abonado */}
                    <div className="col-xl-3 col-md-6 mb-4">
                        <Card id={"planAmount"} cardColorClass={"border-left-danger"} titleColorClass={"text-danger"} text={"Nº planes abonado"} iconClass={"fa-exclamation"} />
                    </div>
                    {/* Card numero fertilizantes */}
                    <div className="col-xl-3 col-md-6 mb-4">
                        <Card id={"fertilizeAmount"} cardColorClass={"border-left-danger"} titleColorClass={"text-danger"} text={"Nº fertilizantes"} iconClass={"fa-exclamation"} />
                    </div>
                    {/* Card numero labores */}
                    <div className="col-xl-3 col-md-6 mb-4">
                        <Card id={"workAmount"} cardColorClass={"border-left-danger"} titleColorClass={"text-danger"} text={"Nº labores"} iconClass={"fa-exclamation"} />
                    </div>
                    {/* Card numero actividades cubiertas */}
                    <div className="col-xl-3 col-md-6 mb-4">
                        <Card id={"coverActivityAmount"} cardColorClass={"border-left-danger"} titleColorClass={"text-danger"} text={"Nº actividades cubiertas"} iconClass={"fa-exclamation"} />
                    </div>
                    {/* Card numero riegos */}
                    <div className="col-xl-3 col-md-6 mb-4">
                        <Card id={"irrigationAmount"} cardColorClass={"border-left-danger"} titleColorClass={"text-danger"} text={"Nº riego"} iconClass={"fa-exclamation"} />
                    </div>
                    {/* Card numero infecciones */}
                    <div className="col-xl-3 col-md-6 mb-4">
                        <Card id={"infectionAmount"} cardColorClass={"border-left-danger"} titleColorClass={"text-danger"} text={"Nº infecciones"} iconClass={"fa-exclamation"} />
                    </div>
                    {/* Card numero estados fenologicos */}
                    <div className="col-xl-3 col-md-6 mb-4">
                        <Card id={"stateAmount"} cardColorClass={"border-left-danger"} titleColorClass={"text-danger"} text={"Nº estados fenológicos"} iconClass={"fa-exclamation"} />
                    </div>
                    {/* Card numero recolectas */}
                    <div className="col-xl-3 col-md-6 mb-4">
                        <Card id={"collectAmount"} cardColorClass={"border-left-danger"} titleColorClass={"text-danger"} text={"Nº recolectas"} iconClass={"fa-exclamation"} />
                    </div>
                    {/* Card numero recolectas */}
                    <div className="col-xl-3 col-md-6 mb-4">
                    <Card id={"noteAmount"} cardColorClass={"border-left-danger"} titleColorClass={"text-danger"} text={"Nº notas"} iconClass={"fa-exclamation"} />
                    </div>
                    {/* Card nº de incidencias (guest)*/}
                    <div className="col-xl-3 col-md-6 mb-4">
                        <Card id={"guestAmount"} cardColorClass={"border-left-danger"} titleColorClass={"text-danger"} text={"Nº visitas"} iconClass={"fa-exclamation"} />
                    </div>
                </div>

                {/* Page Heading */}
                <PageTitle text={"Gráficas generales"}/>
                <div className="row">
                    <div className="col-xl-12 col-md-12">
                        {/* User Area Chart */}
                        <DashboardGraph resetZoom={this.props.strings.resetZoom} triggerId={"collapseUserAreaChartCardTrigger"} collapseId={"collapseUserAreaChartCard"} chartId={"userAreaChart"} cardTitleClass={"text-primary"} cardTitle={this.props.strings.dashboardUser} cardShadow={true} btnFunction={() => this.resetChart(0)} />
                        {/* Season Area Chart */}
                        <DashboardGraph resetZoom={this.props.strings.resetZoom} triggerId={"collapseSeasonAreaChartCardTrigger"} collapseId={"collapseSeasonAreaChartCard"} chartId={"seasonAreaChart"} cardTitleClass={"text-primary"} cardTitle={this.props.strings.dashboardSeason} cardShadow={true} btnFunction={() => this.resetChart(1)} />
                        {/* Crop Area Chart */}
                        <DashboardGraph resetZoom={this.props.strings.resetZoom} triggerId={"collapseCropAreaChartCardTrigger"} collapseId={"collapseCropAreaChartCard"} chartId={"cropAreaChart"} cardTitleClass={"text-primary"} cardTitle={this.props.strings.dashboardCrop} cardShadow={true} btnFunction={() => this.resetChart(2)} />
                        {/* Machine Area Chart */}
                        <DashboardGraph resetZoom={this.props.strings.resetZoom} triggerId={"collapseMachineAreaChartCardTrigger"} collapseId={"collapseMachineAreaChartCard"} chartId={"machineAreaChart"} cardTitleClass={"text-primary"} cardTitle={this.props.strings.dashboardMachine} cardShadow={true} btnFunction={() => this.resetChart(3)} />
                        {/* Message Area Chart */}
                        <DashboardGraph resetZoom={this.props.strings.resetZoom} triggerId={"collapseMessageAreaChartCardTrigger"} collapseId={"collapseMessageAreaChartCard"} chartId={"messageAreaChart"} cardTitleClass={"text-primary"} cardTitle={this.props.strings.dashboardMessage} cardShadow={true} btnFunction={() => this.resetChart(4)} />
                        {/* Notification Area Chart */}
                        <DashboardGraph resetZoom={this.props.strings.resetZoom} triggerId={"collapseNotificationAreaChartCardTrigger"} collapseId={"collapseNotificationAreaChartCard"} chartId={"notificationAreaChart"} cardTitleClass={"text-primary"} cardTitle={this.props.strings.dashboardNotification} cardShadow={true} btnFunction={() => this.resetChart(5)} />
                    </div>
                </div>

                {/* Page Heading */}
                <PageTitle text={"Gráficas incidencias"}/>
                <div className="row">
                    <div className="col-xl-12 col-md-12">
                        {/* Siembra/seed Area Chart */}
                        <DashboardGraph resetZoom={this.props.strings.resetZoom} triggerId={"collapseSeedAreaChartCardTrigger"} collapseId={"collapseSeedAreaChartCard"} chartId={"seedAreaChart"} cardTitleClass={"text-primary"} cardTitle={this.props.strings.dashboardSeed} cardShadow={true} btnFunction={() => this.resetChart(6)} />
                        {/* Plantaciones/plant Area Chart */}
                        <DashboardGraph resetZoom={this.props.strings.resetZoom} triggerId={"collapsePlantAreaChartCardTrigger"} collapseId={"collapsePlantAreaChartCard"} chartId={"plantAreaChart"} cardTitleClass={"text-primary"} cardTitle={this.props.strings.dashboardPlant} cardShadow={true} btnFunction={() => this.resetChart(7)} />
                        {/* Cubierta/cover Area Chart */}
                        <DashboardGraph resetZoom={this.props.strings.resetZoom} triggerId={"collapseCoverAreaChartCardTrigger"} collapseId={"collapseCoverAreaChartCard"} chartId={"coverAreaChart"} cardTitleClass={"text-primary"} cardTitle={this.props.strings.dashboardCover} cardShadow={true} btnFunction={() => this.resetChart(8)} />
                        {/* Shepherd/Pastoreo Area Chart */}
                        <DashboardGraph resetZoom={this.props.strings.resetZoom} triggerId={"collapseShepherdAreaChartCardTrigger"} collapseId={"collapseShepherdAreaChartCard"} chartId={"shepherdAreaChart"} cardTitleClass={"text-primary"} cardTitle={this.props.strings.dashboardShepherd} cardShadow={true} btnFunction={() => this.resetChart(9)} />
                        {/* Phytosanitary Area Chart */}
                        <DashboardGraph resetZoom={this.props.strings.resetZoom} triggerId={"collapsePhytosanitaryAreaChartCardTrigger"} collapseId={"collapsePhytosanitaryAreaChartCard"} chartId={"phytosanitaryAreaChart"} cardTitleClass={"text-primary"} cardTitle={this.props.strings.dashboardPhytosanitary} cardShadow={true} btnFunction={() => this.resetChart(10)} />
                        {/* Defense/Trat. no quimico Area Chart */}
                        <DashboardGraph resetZoom={this.props.strings.resetZoom} triggerId={"collapseDefenseAreaChartCardTrigger"} collapseId={"collapseDefenseAreaChartCard"} chartId={"defenseAreaChart"} cardTitleClass={"text-primary"} cardTitle={this.props.strings.dashboardDefense} cardShadow={true} btnFunction={() => this.resetChart(11)} />
                        {/* Plan abonado/plan Area Chart */}
                        <DashboardGraph resetZoom={this.props.strings.resetZoom} triggerId={"collapsePlanAreaChartCardTrigger"} collapseId={"collapsePlanAreaChartCard"} chartId={"planAreaChart"} cardTitleClass={"text-primary"} cardTitle={this.props.strings.dashboardPlan} cardShadow={true} btnFunction={() => this.resetChart(12)} />
                        {/* Fertilize Area Chart */}
                        <DashboardGraph resetZoom={this.props.strings.resetZoom} triggerId={"collapseFertilizeAreaChartCardTrigger"} collapseId={"collapseFertilizeAreaChartCard"} chartId={"fertilizeAreaChart"} cardTitleClass={"text-primary"} cardTitle={this.props.strings.dashboardFertilize} cardShadow={true} btnFunction={() => this.resetChart(13)} />
                        {/* Work Area Chart */}
                        <DashboardGraph resetZoom={this.props.strings.resetZoom} triggerId={"collapseWorkAreaChartCardTrigger"} collapseId={"collapseWorkAreaChartCard"} chartId={"workAreaChart"} cardTitleClass={"text-primary"} cardTitle={this.props.strings.dashboardWork} cardShadow={true} btnFunction={() => this.resetChart(14)} />
                        {/* Actividad sobre Cubierta/coverActivity Area Chart */}
                        <DashboardGraph resetZoom={this.props.strings.resetZoom} triggerId={"collapseCoverActivityAreaChartCardTrigger"} collapseId={"collapseCoverActivityAreaChartCard"} chartId={"coverActivityAreaChart"} cardTitleClass={"text-primary"} cardTitle={this.props.strings.dashboardCoverActivity} cardShadow={true} btnFunction={() => this.resetChart(15)} />
                        {/* Irrigation Area Chart */}
                        <DashboardGraph resetZoom={this.props.strings.resetZoom} triggerId={"collapseIrrigationAreaChartCardTrigger"} collapseId={"collapseIrrigationAreaChartCard"} chartId={"irrigationAreaChart"} cardTitleClass={"text-primary"} cardTitle={this.props.strings.dashboardIrrigation} cardShadow={true} btnFunction={() => this.resetChart(16)} />
                        {/* Infection Area Chart */}
                        <DashboardGraph resetZoom={this.props.strings.resetZoom} triggerId={"collapseInfectionAreaChartCardTrigger"} collapseId={"collapseInfectionAreaChartCard"} chartId={"infectionAreaChart"} cardTitleClass={"text-primary"} cardTitle={this.props.strings.dashboardInfection} cardShadow={true} btnFunction={() => this.resetChart(17)} />
                        {/* Estado fenológico/state Area Chart */}
                        <DashboardGraph resetZoom={this.props.strings.resetZoom} triggerId={"collapseStateAreaChartCardTrigger"} collapseId={"collapseStateAreaChartCard"} chartId={"stateAreaChart"} cardTitleClass={"text-primary"} cardTitle={this.props.strings.dashboardState} cardShadow={true} btnFunction={() => this.resetChart(18)} />
                        {/* Collect Area Chart */}
                        <DashboardGraph resetZoom={this.props.strings.resetZoom} triggerId={"collapseCollectAreaChartCardTrigger"} collapseId={"collapseCollectAreaChartCard"} chartId={"collectAreaChart"} cardTitleClass={"text-primary"} cardTitle={this.props.strings.dashboardCollect} cardShadow={true} btnFunction={() => this.resetChart(19)} />
                        {/* Note Area Chart */}
                        <DashboardGraph resetZoom={this.props.strings.resetZoom} triggerId={"collapseNoteAreaChartCardTrigger"} collapseId={"collapseNoteAreaChartCard"} chartId={"noteAreaChart"} cardTitleClass={"text-primary"} cardTitle={this.props.strings.dashboardNote} cardShadow={true} btnFunction={() => this.resetChart(20)} />
                        {/* Guest Area Chart */}
                        <DashboardGraph resetZoom={this.props.strings.resetZoom} triggerId={"collapseGuestAreaChartCardTrigger"} collapseId={"collapseGuestAreaChartCard"} chartId={"guestAreaChart"} cardTitleClass={"text-primary"} cardTitle={this.props.strings.dashboardGuest} cardShadow={true} btnFunction={() => this.resetChart(21)} />
                    </div>
                </div>
            </div>
        );
    }

    // Rellena la información de las cards de dashboard.
    fillBasicInformationDashboard = (dashboard) => {
        //Se estabece el numero de usuarios registrados
        document.getElementById("userAmount").innerHTML = dashboard.infoUserAmount();
        //Se estabece el numero de explotaciones registradas
        document.getElementById("farmAmount").innerHTML = dashboard.infoFarmAmount();
        //Se estabece el numero de temporadas registradas
        document.getElementById("seasonAmount").innerHTML = dashboard.infoSeasonAmount();
        //Se estabece el numero de cultivos plantados
        document.getElementById("cropAmount").innerHTML = dashboard.infoCropAmount();
        //Se estabece el numero de maquinaria registrada
        document.getElementById("machineAmount").innerHTML = dashboard.infoMachineAmount();
        //Se estabece el numero de maquinaria registrada
        document.getElementById("messageAmount").innerHTML = dashboard.infoMessageAmount();
        //Se estabece el numero de maquinaria registrada
        document.getElementById("notificationAmount").innerHTML = dashboard.infoNotificationAmount();

        //Se estabece el numero de siembras detectadas
        document.getElementById("seedAmount").innerHTML = dashboard.incidence.infoSeedAmount();
        //Se estabece el numero de plantaciones detectadas
        document.getElementById("plantAmount").innerHTML = dashboard.incidence.infoPlantAmount();
        //Se estabece el numero de cubiertas detectadas
        document.getElementById("coverAmount").innerHTML = dashboard.incidence.infoCoverAmount();
        //Se estabece el numero de pastoreos realizados
        document.getElementById("shepherdAmount").innerHTML = dashboard.incidence.infoShepherdAmount();
        //Se estabece el numero de fitosanitarios aplicados
        document.getElementById("phytosanitaryAmount").innerHTML = dashboard.incidence.infoPhytosanitaryAmount();
        //Se estabece el numero de trat no quimicos aplicados
        document.getElementById("defenseAmount").innerHTML = dashboard.incidence.infoDefenseAmount();
        //Se estabece el numero de planes de abonado detectadas
        document.getElementById("planAmount").innerHTML = dashboard.incidence.infoPlanAmount();
        //Se estabece el numero de fertilizantes aplicados
        document.getElementById("fertilizeAmount").innerHTML = dashboard.incidence.infoFertilizeAmount();
        //Se estabece el numero de labores realizadas
        document.getElementById("workAmount").innerHTML = dashboard.incidence.infoWorkAmount();
        //Se estabece el numero de actividades sobre cubiertas detectadas
        document.getElementById("coverActivityAmount").innerHTML = dashboard.incidence.infoCoverActivityAmount();
        //Se estabece el numero de riego realizado
        document.getElementById("irrigationAmount").innerHTML = dashboard.incidence.infoIrrigationAmount();
        //Se estabece el numero de infecciones detectadas
        document.getElementById("infectionAmount").innerHTML = dashboard.incidence.infoInfectionAmount();
        //Se estabece el numero de estados fenologicos detectadas
        document.getElementById("stateAmount").innerHTML = dashboard.incidence.infoStateAmount();
        //Se estabece el numero de recolectas realizadas
        document.getElementById("collectAmount").innerHTML = dashboard.incidence.infoCollectAmount();
        //Se estabece el numero de notas guardadas
        document.getElementById("noteAmount").innerHTML = dashboard.incidence.infoNoteAmount();
        //Se estabece el numero de notas guardadas
        document.getElementById("guestAmount").innerHTML = dashboard.incidence.infoGuestAmount();
    }

    // Rellena los gráficos de dashboard.
    fillChartInformationDashboard = (dashboard) => {
        this.graphs[0] = this.drawChart(document.getElementById("userAreaChart"), this.getAreaChartLabels(dashboard.user),
            this.props.strings.dashboardNUser, this.getAreaChartData(dashboard.user));
        this.graphs[1] = this.drawChart(document.getElementById("seasonAreaChart"), this.getAreaChartLabels(dashboard.season),
            this.props.strings.dashboardNSeason, this.getAreaChartData(dashboard.season));
        this.graphs[2] = this.drawChart(document.getElementById("cropAreaChart"), this.getAreaChartLabels(dashboard.incidence.crop),
            this.props.strings.dashboardNCrop, this.getAreaChartData(dashboard.incidence.crop));
        this.graphs[3] = this.drawChart(document.getElementById("machineAreaChart"), this.getAreaChartLabels(dashboard.machine),
            this.props.strings.dashboardNMachine, this.getAreaChartData(dashboard.machine));
        this.graphs[4] = this.drawChart(document.getElementById("messageAreaChart"), this.getAreaChartLabels(dashboard.message),
            this.props.strings.dashboardNMessage, this.getAreaChartData(dashboard.message));
        this.graphs[5] = this.drawChart(document.getElementById("notificationAreaChart"), this.getAreaChartLabels(dashboard.notification),
            this.props.strings.dashboardNNotification, this.getAreaChartData(dashboard.notification));

        this.graphs[6] = this.drawChart(document.getElementById("seedAreaChart"), this.getAreaChartLabels(dashboard.incidence.seed),
            this.props.strings.dashboardNSeed, this.getAreaChartData(dashboard.incidence.seed));
        this.graphs[7] = this.drawChart(document.getElementById("plantAreaChart"), this.getAreaChartLabels(dashboard.incidence.plant),
            this.props.strings.dashboardNPlant, this.getAreaChartData(dashboard.incidence.plant));
        this.graphs[8] = this.drawChart(document.getElementById("coverAreaChart"), this.getAreaChartLabels(dashboard.incidence.cover),
            this.props.strings.dashboardNCover, this.getAreaChartData(dashboard.incidence.cover));
        this.graphs[9] = this.drawChart(document.getElementById("shepherdAreaChart"), this.getAreaChartLabels(dashboard.incidence.shepherd),
            this.props.strings.dashboardNShepherd, this.getAreaChartData(dashboard.incidence.shepherd));
        this.graphs[10] = this.drawChart(document.getElementById("phytosanitaryAreaChart"), this.getAreaChartLabels(dashboard.incidence.phytosanitary),
            this.props.strings.dashboardNPhytosanitary, this.getAreaChartData(dashboard.incidence.phytosanitary));
        this.graphs[11] = this.drawChart(document.getElementById("defenseAreaChart"), this.getAreaChartLabels(dashboard.incidence.defense),
            this.props.strings.dashboardNDefense, this.getAreaChartData(dashboard.incidence.defense));
        this.graphs[12] = this.drawChart(document.getElementById("planAreaChart"), this.getAreaChartLabels(dashboard.incidence.plan),
            this.props.strings.dashboardNPlan, this.getAreaChartData(dashboard.incidence.plan));
        this.graphs[13] = this.drawChart(document.getElementById("fertilizeAreaChart"), this.getAreaChartLabels(dashboard.incidence.fertilize),
            this.props.strings.dashboardNFertilize, this.getAreaChartData(dashboard.incidence.fertilize));
        this.graphs[14] = this.drawChart(document.getElementById("workAreaChart"), this.getAreaChartLabels(dashboard.incidence.work),
            this.props.strings.dashboardNWork, this.getAreaChartData(dashboard.incidence.work));
        this.graphs[15] = this.drawChart(document.getElementById("coverActivityAreaChart"), this.getAreaChartLabels(dashboard.incidence.coveractivity),
            this.props.strings.dashboardNCoverActivity, this.getAreaChartData(dashboard.incidence.coveractivity));
        this.graphs[16] = this.drawChart(document.getElementById("irrigationAreaChart"), this.getAreaChartLabels(dashboard.incidence.irrigation),
            this.props.strings.dashboardNIrrigation, this.getAreaChartData(dashboard.incidence.irrigation));
        this.graphs[17] = this.drawChart(document.getElementById("infectionAreaChart"), this.getAreaChartLabels(dashboard.incidence.infection),
            this.props.strings.dashboardNInfection, this.getAreaChartData(dashboard.incidence.infection));
        this.graphs[18] = this.drawChart(document.getElementById("stateAreaChart"), this.getAreaChartLabels(dashboard.incidence.state),
            this.props.strings.dashboardNState, this.getAreaChartData(dashboard.incidence.state));
        this.graphs[19] = this.drawChart(document.getElementById("collectAreaChart"), this.getAreaChartLabels(dashboard.incidence.collect),
            this.props.strings.dashboardNCollect, this.getAreaChartData(dashboard.incidence.collect));
        this.graphs[20] = this.drawChart(document.getElementById("noteAreaChart"), this.getAreaChartLabels(dashboard.incidence.note),
            this.props.strings.dashboardNNote, this.getAreaChartData(dashboard.incidence.note));
        this.graphs[21] = this.drawChart(document.getElementById("guestAreaChart"), this.getAreaChartLabels(dashboard.incidence.guest),
            this.props.strings.dashboardNGuest, this.getAreaChartData(dashboard.incidence.guest));
    }

    // Dibuja un gráfico.
    drawChart = (chart, labels, labelName, data) => {
        // noinspection JSCheckFunctionSignatures
        return new Chart(chart, {
            type: 'line',
            data: {
                labels: labels,
                datasets: [{
                    lineTension: 0.3,
                    backgroundColor: "rgba(78, 115, 223, 0.05)",
                    borderColor: "rgba(78, 115, 223, 1)",
                    pointRadius: 3,
                    pointBackgroundColor: "rgba(78, 115, 223, 1)",
                    pointBorderColor: "rgba(78, 115, 223, 1)",
                    pointHoverRadius: 3,
                    pointHoverBackgroundColor: "rgba(78, 115, 223, 1)",
                    pointHoverBorderColor: "rgba(78, 115, 223, 1)",
                    pointHitRadius: 10,
                    pointBorderWidth: 2,
                    label: labelName,
                    data: data
                }]
            },
            options: {
                maintainAspectRatio: false,
                layout: {
                    padding: {
                        left: 10,
                        right: 25,
                        top: 25,
                        bottom: 0
                    }
                },
                scales: {
                    x: {
                        grid: {
                            display: false,
                            drawBorder: false
                        },
                        ticks: {
                            maxTicksLimit: 7
                        },
                        time: {
                            unit: 'date'
                        }
                    },
                    y: {
                        grid: {
                            color: "rgb(234, 236, 244)",
                            drawBorder: false,
                            borderDash: [2],
                        },
                        ticks: {
                            maxTicksLimit: 5,
                            padding: 10,
                        }
                    }
                },
                transitions: {
                  zoom: {
                      animation: {
                          duration: 1000
                      }
                  }
                },
                plugins: {
                    zoom: {
                        // Container for zoom options
                        zoom: {
                            drag: {
                                enabled: true
                            },
                            wheel: {
                                enabled: false,
                            },
                            mode: 'x'
                        },
                        pan: {
                            enabled: true,
                            mode: 'x'
                        }
                    },
                    legend: {
                        display: false
                    },
                    tooltips: {
                        backgroundColor: "rgb(255,255,255)",
                        bodyFontColor: "#858796",
                        titleMarginBottom: 10,
                        titleFontColor: '#6e707e',
                        titleFontSize: 14,
                        borderColor: '#dddfeb',
                        borderWidth: 1,
                        xPadding: 15,
                        yPadding: 15,
                        displayColors: false,
                        intersect: false,
                        mode: 'index',
                        caretPadding: 10
                    }
                }
            }
        });
    }

    // Devuelve las labels de los gráficos.
    getAreaChartLabels = (dashboardDays) => {
        let result = [];
        for (let i in dashboardDays){
            result.push(dashboardDays[i].areaChartLabel());
        }
        return result;
    }

    // Devuelve los datos d elos gráficos.
    getAreaChartData = (dashboardDays) => {
        let result = [];
        for (let i in dashboardDays){
            result.push(dashboardDays[i].areaChartData());
        }
        return result;
    }

    resetChart = (index) => {
        this.graphs[index].resetZoom();
    } 

}

export default Dashboard;